<template>
  <section>
    <div class="has-border-light has-border-radius p-3">
      <div class="is-flex is-justify-content-space-between is-align-items-flex-start m-b-20">
        <img class="m-t-5" src="@/assets/illustrations/coins.svg" alt="" />
        <div class="m-l-10">
          <p class="is-size-4 has-text-weight-semibold">{{ $t('tax.asset-other-income') }}</p>
          <p class="is-size-5">{{ $t('tax.asset-other-income-desc') }}</p>
        </div>
      </div>
      <FormCurrency
        class="m-l-20"
        :value="computedValue"
        icon="currency-dollar"
        :placeholder="$t('tax.asset-other-income-placeholder')"
        :show-currency-select="false"
        :currency="PredefinedCurrency.CAD.id"
        :has-fixed-label="true"
        @input="onInputChange"
      />
    </div>
  </section>
</template>

<script>
import FormCurrency from '@/modules/core/form/components/FormCurrency.vue';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';
import { PredefinedCurrency } from '@/modules/predefined/enums/PredefinedCurrency';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesOtherIncomeInput',
  emits: ['input'],
  mixins: [FormComputedValueMixin],
  components: { FormCurrency },
  static: {
    PredefinedCurrency
  },
  methods: {
    onInputChange(value) {
      const parsedValue = Number(value);
      this.computedValue = parsedValue;
      this.$emit('input', parsedValue);
    }
  }
};
</script>
